<template>
  <div class="conten-box"
       v-if="queryNum <= 0">
    <van-nav-bar v-if="!hideHeader"
                 class="header"
                 :title="title"
                 :border="false"
                 @click-left="onClickClose">
      <template #left
                v-if="citingSourcesType !== 1">
        <van-icon :name='require("@/assets/images/oralExpression/icon-close.png")'
                  size="22" />
      </template>
    </van-nav-bar>
    <div class="cont">
      <div class="progress"
           v-if="!hideHeader">
        <van-progress :percentage="percentage"
                      :show-pivot="false"
                      color="#45D585"
                      stroke-width="4" />
      </div>
      <div class="wapper"
           ref="wapper"
           :style='"padding-bottom:"+ paddingBottom +"px;"'>
        <div class="w-title"
             ref="title"
             :class="hideHeader ? 'noShow':''">
          <!--          <span class="tag"-->
          <!--                v-if="!hideHeader">模拟跟读</span>-->
          <!--          <div class="msg"-->
          <!--               v-if="!hideHeader">-->
          <!--            {{ stems ? stems : "Hi，认真听，点击录音进行跟读" }}-->
          <!--          </div>-->
          <div class="msg"
               v-if="stems"
               v-html="stems">
          </div>
          <div class="msg"
               v-else>
            Hi，认真听，点击录音进行跟读
          </div>
        </div>
        <div class="player-box"
             v-if="audioUrl">
          <zhlAplayer :url="audioUrl"
                      ref="zhlAplayer" />
        </div>
        <div class="msg-box"
             ref="msgBox"
             v-if="hideHeader">
          <div class="textBox"
               v-if="messageList[0]"
               v-html="messageList[0].msg">
          </div>
          <template v-for="(item, i) in messageList">
            <message v-if="hideHeader && item.type !=='left'"
                     :key="i"
                     :readData="item"
                     @setScroll="setScrollFun"
                     @readThisMessage="readThisMessageFun"
                     @reluyin="reluyinFun" />
          </template>
        </div>
        <div class="msg-box"
             ref="msgBox"
             v-else>
          <template v-for="(item, i) in messageList">
            <message :key="i"
                     :readData="item"
                     @setScroll="setScrollFun"
                     @readThisMessage="readThisMessageFun"
                     @reluyin="reluyinFun" />
          </template>
        </div>
      </div>
    </div>
    <div class="footer"
         v-show="!hideFooter"
         v-if="!hideHeader && !record_id">
      <div class="footer-item">
        <van-icon v-if="percentage != 100 || isPlaying"
                  :name='require("@/assets/images/oralExpression/icon-fanish-disable.png")'
                  size="40" />
        <van-icon v-else
                  @click="fanish"
                  :name='require("@/assets/images/oralExpression/icon-fanish.png")'
                  size="40" />
        <div class="name">完成</div>
      </div>
      <div class="footer-item">
        <div v-if="isPlaying || !askLuyin"
             class="backGroundLuYin"
             :style="{backgroundImage: 'url('+ require('@/assets/images/oralExpression/icon-luyin-disable.png') +')'}">
        </div>
        <div v-else
             @click="send"
             class="backGroundLuYin"
             :style="{backgroundImage: 'url('+ require('@/assets/images/oralExpression/icon-luyin.png') +')'}">
        </div>
        <!--        <van-icon v-if="isPlaying || !askLuyin"-->
        <!--                  :name='require("@/assets/images/oralExpression/icon-luyin-disable.png")'-->
        <!--                  size="92"/>-->
        <!--        <van-icon v-else-->
        <!--                  @click="send"-->
        <!--                  :name='require("@/assets/images/oralExpression/icon-luyin.png")'-->
        <!--                  size="92"/>-->
        <div class="name">{{ theName }}</div>
      </div>
      <div class="footer-item">
        <van-icon v-if="isPlaying || askLuyin || currentIndex == listArr.length"
                  :name='require("@/assets/images/oralExpression/icon-next-disable.png")'
                  size="40" />
        <van-icon v-else-if="currentIndex==0"
                  @click="aiSend(0)"
                  :name='require("@/assets/images/oralExpression/icon-next.png")'
                  size="40" />
        <van-icon v-else
                  @click="nextReading"
                  :name='require("@/assets/images/oralExpression/icon-next.png")'
                  size="40" />
        <div class="name">{{ currentIndex == 0 ? "开始" : "下一句" }}</div>
      </div>
    </div>
    <div class="footer showCountDown"
         v-if="hideHeader && showCountDown">
      <van-count-down :time="showCountDownTime"
                      @finish="finishCountDown"
                      format="ss" />
      <div class="text">倒计时结束将开始录音，请做好准备</div>
    </div>
    <div class="footer"
         v-if="isLuing && hideHeader"></div>
    <div class="asklu"
         v-if="isLuing"
         @click="stopLu">
      <div class="progressBox"
           v-if="hideHeader">
        <div class="pro">
          <van-progress :percentage="luGrade"
                        stroke-width="3"
                        :show-pivot="false"
                        color="#45D585"
                        track-color="#BFBFBF" />
        </div>

        <div class="timeBox">{{ luTimeStr }}</div>
      </div>
      <div class="waveBox">
        <WaveView />
      </div>
      <!--      <div class="text"-->
      <!--           v-if="!hideHeader">点击波纹，结束录音-->
      <!--      </div>-->
      <!--      <div class="text"-->
      <!--           v-else>请在指定时间内完成录音或点击波纹结束录音-->
      <!--      </div>-->
      <div class="stopLuBtn">
        <div>停止录音</div>
      </div>
    </div>
    <div class="player">
      <!-- <aplayer class="myAudio"
        ref="aplayer"
        theme="#5A95FD"
        loop="none"
        @timeupdate="playingFun"
        @ended="playEnd"
        @error="playError"
        :audio="currentMusic" /> -->
      <audio :src="currentMusic.url"
             @timeupdate="playingFun"
             @ended="playEnd"
             @pause="pauseAudio"
             @error="playError"
             :loop="false"
             ref="aplayer"
             controls="controls"></audio>
    </div>
    <getVipTip :show="showGetVipAlert && !hideHeader"
               title="欢迎使用模拟跟读功能"
               @getVip="getVipFun"
               @close="showGetVipAlert = false" />
    <closeOral :show="showCloseOral"
               :type="closeOralType"
               @nextClick="goToNextMoudle"
               @close="showCloseOral = false" />
    <OralExpressionF :show="showOralExpressionF"
                     @close="showOralExpressionF = false" />
    <van-popup v-model="showAskOne"
               class="showFAlertBox"
               :get-container="getContainer"
               :close-on-click-overlay="false">
      <div class="showFAlert">
        <div class="title">提示</div>
        <div class="msg">仅有一次重录机会，确定要重录吗？</div>
        <div class="btns">
          <van-button round
                      type="primary"
                      @click="quxiaoRelu">取消
          </van-button>
          <van-button round
                      type="primary"
                      @click="askTheRelu">确认
          </van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { HttpFactory, getArgs, iosOrAndroid, zhlType, getCookie, md5 } from '@/assets/js/common'
import { httpBuilderUrl, jumpPageUrlWeb, basePageUrlWeb } from '@/assets/js/utils'
import rqParams from './rq.js'
// import '@/assets/js/engine.js'
// import wx from '@/assets/js/wxjssdk.js'
// import Oral from '@/assets/js/zhloralMain.js'
import OralweChat from '@/assets/js/zhlOralweChat.js'
import zhlAplayer from '@/components/Aplayer/index'
import message from '@/components/Message/index'
import getVipTip from '@/components/OralExpressionComponents/OralExpressionGetVip'
import closeOral from '@/components/OralExpressionComponents/OralExpressionClose'
import OralExpressionF from '@/components/OralExpressionComponents/OralExpressionF'
import WaveView from '@/components/EnglishComponents/WaveView'
import { iseRecorder } from '@/assets/js/kdxf.js'

let lastTime = 0
export default {
  name: 'oralExpression',
  components: {
    message,
    getVipTip,
    zhlAplayer,
    closeOral,
    OralExpressionF,
    WaveView
  },
  props: {
    theGuid: {
      type: String,
      default: ''
    },
    hideHeader: {
      type: Boolean,
      default: false
    },
    questionItem: {
      type: Object
    },
    entry: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      business_id: null,
      showOralExpressionF: false,
      stems: '',
      audioUrl: '', // 原文的音频
      luGrade: 0,
      luTimeStr: '00:00/00:00',
      showCountDown: false,
      showCountDownTime: 0,
      showAskOne: false,

      isIOSWx: false,
      access_token: '',
      refText: '',
      isRoot: false,

      isLuing: false,
      hideFooter: false,
      showGetVipAlert: false,
      showCloseOral: false,
      closeOralType: 'close',
      queryNum: 0,
      title: '',
      listArr: [],
      isShowGetVip: false,
      currentIndex: 0,
      currentObj: {
        isPlaying: false
      },
      percentage: 0, // 进度条
      messageList: [], // 消息队列
      currentMusic: {
        name: '',
        artist: '',
        url: ''
      },
      paddingBottom: 0,
      height: 0,
      timer: null,
      timer2: null,
      timer3: null,
      askLuyin: false, // 重新录音
      rePlaying: false, // 重听
      isPlaying: false, // 全局的播放状态
      theName: '点击录音',
      userInfo: {},
      nextList: [],
      guid: '',
      book_id: '',
      resource_id: '',
      model_id: '',
      type: '',
      pageType: 1, // 目前写的页码模式，还有一个目录模式
      model_question: {}, // 单个模块打开得题目信息
      citingSourcesType: null,
      record_id: 0,
      book_info: {}
    }
  },
  watch: {
    messageList(val) {
      const total = this.listArr.length * 2
      let num = 0
      val.forEach((el) => {
        if (el.type != 'other') {
          // 说明是正常对话
          num++
        } else {
          this.isShowGetVip = true
        }
      })
      const newNum = parseInt((num / total) * 100)
      const oldNum = this.percentage
      this.numFun(oldNum, newNum, (data) => {
        this.percentage = data
        if (this.hideHeader && this.percentage == 100) {
          this.fanish()
        }
      })
    },
    currentObj(val) {
      this.isPlaying = true
      this.currentMusic.url = val.url
      this.timer && clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        if (this.currentMusic.url) {
          if (this.messageList.length === 2 && iosOrAndroid() == 'ios') { // ios手机特殊处理，异步加载音频需要后续有交互才可以自动播放
            this.currentObj.isPlaying = false
            this.isPlaying = false
          } else {
            this.$refs.aplayer.play()
          }
        } else {
          if (this.hideHeader) {
            this.playingFun()
          } else {
            this.playEnd()
          }
        }
      }, 100)
    },
    questionItem(obj) {
    }
  },
  created() {
    console.log(111)
    // window.oralRecAndEvaCallback = this.oralRecAndEvaCallback
  },
  mounted() {
    const param = getArgs()
    this.guid = this.theGuid || param.guid
    this.book_id = param.book_id || 0
    this.title = param.title
    this.resource_id = param.resource_id
    this.model_id = param.model_id
    this.type = param.type
    this.son_type = Number(param.son_type)
    this.if_study = Number(param.if_study)
    this.record_id = Number(param.record_id)
    this.citingSourcesType = Number(param.citingSourcesType)
    this.business_id = Number(zhlType.getBusinessId())
    if (!this.record_id) {
      this.getUserInfo()
      this.getNextList()
    }
    this.getDataList()
    // jumpWebView.handleNavigator(false)
    if (typeof zhlWebView != 'undefined') {
      try {
        zhlWebView.setBouncesEnabled(0) // 禁用ios回弹
      } catch (error) {
      }
    }
    if (iosOrAndroid() == 'ios') {
      var ua = navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        // 是微信打开
        // this.isIOSWx = true
        // this.getweixinjsapiconfigFun()
      } else {
        this.$toast('请使用微信扫码打开，否则无法录音')
        // Oral.initEngine()
      }
    } else {
      // Oral.initEngine()
    }

    if (!this.record_id) {
      // 状态改变时触发
      // iseRecorder.onWillStatusChange = this.onKDXFWillStatusChange
      // 监听识别结果的变化
      // iseRecorder.onTextChange = this.onKDXFTextChange
      iseRecorder.onTextChange = this.oralRecAndEvaCallback
      // 录音权限
      iseRecorder.recorderInit()
    }
  },
  methods: {
    getContainer() {
      return document.querySelector('.conten-box')
    },
    // 倒计时结束事件
    finishCountDown() {
      console.log('计时结束了')
      if (this.showCountDownTime === 0) {
        return false
      }
      if (this.hideHeader) {
        this.$refs.aplayer.pause()
        this.showCountDown = false
        this.$toast('开始录音')
        this.setLuGrate()
        this.send()
      }
    },
    getweixinjsapiconfigFun() {
      const url = location.href
      HttpFactory.postUrlPay(
        rqParams.getweixinjsapiconfig({
          app_id: 137,
          url: url
        }),
        (res) => {
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.data.app_id, // 必填，公众号的唯一标识
            timestamp: res.data.time_stamp, // 必填，生成签名的时间戳
            nonceStr: res.data.nonce_str, // 必填，生成签名的随机串
            signature: res.data.signature, // 必填，签名
            jsApiList: ['startRecord', 'stopRecord', 'uploadVoice'] // 必填，需要使用JS接口列表
          })
          wx.ready(() => {
            this.isRoot = true
          })
        }
      )
    },
    beginLu(msg) {
      if (this.isIOSWx) {
        if (this.isRoot) {
          wx.startRecord()
          this.isLuing = true
          this.refText = msg
        } else {
          this.$toast('麦克风没有被允许')
        }
        return
      }
      // if (!Oral.isRoot) {
      //   this.$toast('麦克风没有被允许')
      //   return
      // }
      this.isLuing = true
      // const type = this.hideHeader ? 'en.pred.score' : 'en.sent.score'
      // Oral.myRecord.startRecord({
      //   coreType: type,
      //   refText: msg,
      //   rateScale: 1.0,
      //   symbol: 1,
      //   attachAudioUrl: 1,
      //   evalTime: null
      // })
      // iseRecorder.text = msg
      iseRecorder.recorderInit({
        text: msg
      })
    },
    stopLu() {
      if (this.hideHeader) {
        clearInterval(this.luTimer)
        this.luTimeStr = '00:00/00:00'
        if (this.showAskOne) {
          this.$emit('fanished', 'footer')
        }
      }
      if (this.isIOSWx) {
        const that = this
        wx.stopRecord({
          success(res) {
            var localId = res.localId
            wx.uploadVoice({
              localId: localId, // 需要上传的音频的本地ID，由stopRecord接口获得
              isShowProgressTips: 1, // 默认为1，显示进度提示
              success(res) {
                var serverId = res.serverId // 返回音频的服务器端ID
                console.log(serverId)
                that.getUrlAndPing(serverId)
              }
            })
          }
        })
      } else {
        // Oral.myRecord.stopRecord()
        this.isLuing = false
        // if (iseRecorder.status === 'ing') {
        iseRecorder.stop()
        // } else {
        //   iseRecorder.start()
        // }
        // this.currentAudioData = iseRecorder.getAudioLocalUrl()
        // console.log(this.currentAudioData)
        // console.log('audioDat=', iseRecorder.audioData)
        // console.log(JSON.stringify(iseRecorder.audioData))
        // this.play(iseRecorder.audioData)
      }
    },
    getUrlAndPing(id) {
      const jsonText = OralweChat.getEvalJson('wechat', this.refText, 'en.sent.score')
      const timestamp = parseInt(new Date().getTime() / 1000) + ''
      const message = 'a658.' + timestamp + '.JSWsbEHxIvTnqPy5oZ7GOzF9LKBNr1UM'
      const sig = OralweChat.sha1(message)
      jsonText.connect.param.app.timestamp = timestamp
      jsonText.connect.param.app.sig = sig
      jsonText.start.param.app.timestamp = timestamp
      jsonText.start.param.app.sig = sig
      HttpFactory.postUrlPay(
        rqParams.getweixinvoicetestinfo({
          media_id: id,
          app_id: 137,
          json_text: JSON.stringify(jsonText),
          is_login: 1
        }),
        (res) => {
          this.isLuing = false
          const data = JSON.parse(res.data)
          const resultData = {}
          resultData.overall = data.result.overall
          resultData.duration = data.result.wavetime / 1000
          resultData.audioUrl = data.audioUrl
          resultData.resultStr = data.refText
          resultData.wordInfosArr = []
          const arr = data.result.details
          arr.forEach((el) => {
            resultData.wordInfosArr.push({
              word: el.char,
              score: el.score
            })
          })
          this.oralRecAndEvaCallback(JSON.stringify(resultData))
        }
      )
    },
    initEvent() {
      window.oralRecAndEvaCallback = this.oralRecAndEvaCallback
    },
    oralRecAndEvaCallback(param) {
      this.hideFooter = false
      var data = JSON.parse(param)
      const isVip = true
      let str = ''
      try {
        str = this.getTheResultStr(data)
      } catch (error) {
        str = '语音识别失败'
      }
      if (isVip) {
        const obj = {
          id: new Date().getTime() + Math.random(),
          url: data.audioUrl,
          avatar_url: this.userInfo.avatar_url,
          audio_duration: data.duration,
          isVip: true,
          type: 'right',
          msg: str,
          grade: data.overall ? data.overall : 0,
          isPlaying: true,
          isAskLuyin: false,
          standard_score: data.standard_score,
          accuracy_score: data.accuracy_score,
          fluency_score: data.fluency_score,
          resultStr: data.resultStr
        }
        const activeBookInfo = sessionStorage.getItem('activeBookInfo')
        let book_name = ''
        if (activeBookInfo) {
          const { name } = JSON.parse(activeBookInfo)
          book_name = name || ''
        }
        iseRecorder.setAudioUrl(obj, {
          formDataBack: (formData) => {
            formData.append('file_path_key', book_name)
          }
        })
        this.currentObj = obj
      } else {
        const obj = {
          id: new Date().getTime() + Math.random(),
          url: data.audioUrl,
          avatar_url: this.userInfo.avatar_url,
          audio_duration: data.duration,
          isVip: false,
          type: 'right',
          msg: str,
          isPlaying: true,
          isAskLuyin: false,
          standard_score: data.standard_score,
          accuracy_score: data.accuracy_score,
          fluency_score: data.fluency_score,
          resultStr: data.resultStr
        }
        iseRecorder.setAudioUrl(obj)
        this.currentObj = obj
      }
      let num = 0
      this.messageList.forEach((el, i) => {
        if (el.isAskLuyin) {
          this.messageList.splice(i, 1, this.currentObj)
          num++
        }
      })
      if (!num) {
        this.messageList.push(this.currentObj)
        if (!this.isShowGetVip && !isVip) {
          this.messageList.push({
            type: 'other',
            msg: '想要查看自己的口语分数吗？'
          })
        }
      }
      this.askLuyin = false
    },
    getTheResultStr(data) {
      var srt = ''
      var obj = {}
      data.wordInfosArr.forEach((el) => {
        srt += el.word + '|'
        if (el.score >= 60) {
          obj[el.word] = '<span class="green">' + el.word + '</span>'
        } else {
          obj[el.word] = '<span class="red">' + el.word + '</span>'
        }
      })
      srt = srt.slice(0, srt.length - 1)
      try {
        const reg = new RegExp('(' + srt + ')', 'gi')
        const newLine = data.resultStr.replace(reg, ($0, $1) => {
          return (obj[$1] || obj[$1.toLowerCase()]) ? (obj[$1] || obj[$1.toLowerCase()]) : $0
        })
        return newLine
      } catch (error) {
        return data.resultStr
      }
    },
    getUserInfo() {
      HttpFactory.postUrl(rqParams.getstudentinfo(), (res) => {
        this.userInfo = Object.assign(this.userInfo, res.data)
      })
      // HttpFactory.postUrl(rqParams.getusermemberinfo(), res => {
      //   this.userInfo = Object.assign(this.userInfo, res.data)
      //   if (this.userInfo.member_type && this.userInfo.member_type != 1) {
      //     // 说明是会员
      //   } else {
      //     HttpFactory.postUrl(
      //       rqParams.getrewardresult({
      //         type: 20
      //       }),
      //       res => {
      //         if (res.data.if_pop) {
      //           // 没有领取过
      //           this.showGetVipAlert = true
      //         }
      //       }
      //     )
      //   }
      // })
    },
    // 领取免费7天会员
    getVipFun() {
      HttpFactory.postUrl(
        rqParams.submitreceivereward({
          type: 20
        }),
        res => {
          if (res.code == 0) {
            this.$toast('领取成功')
          }
          this.getUserInfo()
          this.showGetVipAlert = false
        }
      )
    },
    // 数字动画
    numFun(startNum, maxNum, fn, speed = 1) {
      let numText = startNum
      let golb // 为了清除requestAnimationFrame
      function numSlideFun() {
        // 数字动画
        numText += speed // 速度的计算可以为小数 。数字越大，滚动越快
        if (numText >= maxNum) {
          numText = maxNum
          cancelAnimationFrame(golb)
        } else {
          golb = requestAnimationFrame(numSlideFun)
        }
        fn(numText)
        // console.log(numText)
      }

      numSlideFun() // 调用数字动画
    },
    requestAnimationFrame(fn) {
      const currTime = new Date().getTime()
      // 为了使setTimteout的尽可能的接近每秒60帧的效果
      const timeToCall = Math.max(0, 16 - (currTime - lastTime))
      const id = window.setTimeout(() => {
        fn(currTime + timeToCall)
      }, timeToCall)
      lastTime = currTime + timeToCall
      return id
    },
    cancelAnimationFrame(id) {
      window.clearTimeout(id)
    },
    playError() {
      if (this.messageList.length) {
        console.log('播放失败')
        // this.$toast('播放失败')
      }
    },
    pauseAudio() {
      this.showCountDown = false
    },
    playEnd() {
      if (this.currentObj.type == 'left' && !this.rePlaying) {
        if (this.hideHeader) {
        } else {
          this.$toast({
            message: '点击录音，进行跟读',
            position: 'bottom',
            className: 'zhl-toast-bottom' + (this.theGuid ? ' more' : ''),
            duration: 1000
          })
        }

        this.askLuyin = true
        this.theName = '点击录音'
        // if (this.hideHeader) {
        //   this.showCountDown = false
        //   this.setLuGrate()
        //   this.send()
        // }
      }
      this.currentObj.isPlaying = false
      this.isPlaying = false
      this.rePlaying = false
    },
    setLuGrate() {
      console.log('开始倒计时')
      const questionItem = this.questionItem
      const read_time = Number(questionItem.read_time)
      let time = 0
      this.luTimer && clearInterval(this.luTimer)
      this.luTimer = setInterval(() => {
        time++
        // const total = this.isIOSWx ? 60 : this.questionItem.answer_time
        // console.log(total)
        this.luTimeStr = this.getTimeStr(time, read_time)
        this.luGrade = parseInt((time / read_time) * 100)
        if (time >= read_time) {
          clearInterval(this.luTimer)
          console.log('来了')
          this.stopLu()
        }
      }, 1000)
    },
    getTimeStr(cur, total) {
      const min1 = parseInt(cur / 60) < 10 ? '0' + parseInt(cur / 60) : parseInt(cur / 60)
      const min2 = parseInt(total / 60) < 10 ? '0' + parseInt(total / 60) : parseInt(cur / 60)
      const sec1 = cur % 60 < 10 ? '0' + (cur % 60) : cur % 60
      const sec2 = total % 60 < 10 ? '0' + (total % 60) : total % 60
      return min1 + ':' + sec1 + '/' + min2 + ':' + sec2
    },
    // 播放和暂停
    playingFun() {
      this.$refs.zhlAplayer && this.$refs.zhlAplayer.stop()
      if (this.hideHeader) {
        if (this.currentObj.type == 'left') {
          this.showCountDownTime = parseInt(this.questionItem.read_time || 0) * 1000
          this.showCountDown = true
        }
      }
      // const { media } = this.$refs.aplayer
      // this.currentObj.isPlaying = !media.paused
      // this.isPlaying = !media.paused
      this.currentObj.isPlaying = true
      this.isPlaying = true
    },
    // 重新听
    readThisMessageFun(obj) {
      this.rePlaying = true
      this.messageList.forEach((el) => {
        el.isPlaying = false
        if (el.isAskLuyin) {
          el.isAskLuyin = false
          this.askLuyin = false
        }
      })
      this.currentObj = obj
      if (obj.url.indexOf('?') === -1) {
        this.currentMusic.url = obj.url + '?time=' + new Date().getTime()
      } else {
        this.currentMusic.url = obj.url + '&time=' + new Date().getTime()
      }
      setTimeout(() => {
        this.$refs.aplayer.play()
      }, 100)
    },
    reluyinFun(obj) {
      if (this.entry == 1) {
        this.$toast('当前模式下不能重新录音')
        return
      }
      if (this.isPlaying) {
        this.$toast('播放过程中无法重新录音')
        return
      }
      if (this.askLuyin) {
        this.$toast('请先完成上一次的对话')
        return
      }
      if (this.isAskTheRelu && this.hideHeader) {
        this.$toast('只有一次重新录音的机会')
        return
      }
      this.$refs.zhlAplayer && this.$refs.zhlAplayer.stop()
      this.messageList.forEach((el) => {
        el.isAskLuyin = false
      })
      obj.isAskLuyin = true
      this.askLuyin = true
      if (!this.hideHeader) {
        this.$toast({
          message: '点击录音，重新跟读',
          position: 'bottom',
          className: 'zhl-toast-bottom' + (this.theGuid ? ' more' : ''),
          duration: 1000
        })
        this.thName = '重新录音'
      } else {
        this.showAskOne = true
      }
    },
    askTheRelu() {
      this.showAskOne = false
      this.showCountDown = false
      this.setLuGrate()
      this.send()
      this.isAskTheRelu = true
      this.$emit('fanished', 'disable')
    },
    quxiaoRelu() {
      this.showAskOne = false
      this.messageList.forEach((el) => {
        el.isAskLuyin = false
      })
      this.askLuyin = false
    },
    setScrollFun(el) {
      this.$nextTick(() => {
        const container = this.$refs.wapper
        const title = this.$refs.title
        const msgBox = this.$refs.msgBox
        this.paddingBottom = el.clientHeight
        if (msgBox.clientHeight + title.clientHeight >= container.clientHeight) {
          container.scrollTop = msgBox.clientHeight + title.clientHeight - container.clientHeight + 100
        }
        clearTimeout(this.timer2)
        this.timer2 = setTimeout(() => {
          this.paddingBottom = 0
        }, 300)
      })
    },
    // 点击关闭
    onClickClose() {
      if (this.record_id) {
        this.close()
        return false
      }
      this.showCloseOral = true
      this.closeOralType = 'close'
    },
    close() {
      window.history.go(-1)
    },
    // 点击完成
    fanish() {
      if (this.theGuid && JSON.stringify(this.questionItem) != '{}') {
        this.$emit('fanished', 'footer')
        this.questionItem.if_right = 2
      } else {
        HttpFactory.postUrl(
          rqParams.submitbookstudyrecord({
            book_id: this.book_id,
            type: this.type + 1,
            study_type: 2,
            study_id: this.model_id,
            resource_id: this.resource_id
          }),
          res => {
            this.submitmodeluserstudyrecord().then(res => {
              this.showCloseOral = true
              this.closeOralType = 'all'
            })
          }
        )
      }
    },
    // 提交模块练习记录
    submitmodeluserstudyrecord() {
      return new Promise((resolve, reject) => {
        const model_question = this.model_question
        const messageList = this.messageList
        let score = 0
        let answerLength = 0
        messageList.forEach(item => {
          if (item.type === 'right') {
            answerLength++
            score += item.grade
          }
        })
        score = parseInt(score / answerLength)
        const remark = JSON.stringify({
          guid: model_question.guid,
          model_id: model_question.model_id,
          messageList: messageList
        })
        HttpFactory.postUrl(
          rqParams.submitmodeluserstudyrecord({
            book_id: this.book_id,
            model_id: this.model_id,
            model_type: this.son_type,
            remark: remark,
            score: score
          }),
          res => {
            resolve()
          }
        )
      })
    },
    goToNextMoudle() {
      const nextList = this.deal(JSON.parse(JSON.stringify(this.nextList)), node => {
        return node.model_list.length > 0
      })
      const arr = []
      nextList.forEach((el, i) => {
        arr.push(...el.model_list)
      })
      let item = null
      arr.forEach((el, i) => {
        if (el.model_id == this.model_id) {
          item = arr[i + 1]
        }
      })
      if (item) {
        const parent = this.deal(JSON.parse(JSON.stringify(this.nextList)), node => {
          return JSON.stringify(node.model_list).indexOf(JSON.stringify(item)) > -1
        })
        const data = {
          item,
          parent: parent[0]
        }
        this.goDetailFun(data)
        // this.goqusDetailFun(qus)
      } else {
        this.showCloseOral = false
        this.showOralExpressionF = true
      }
    },
    goDetailFun(data) {
      // HttpFactory.postUrl(
      //   rqParams.submitbookstudyrecord({
      //     book_id: this.book_id,
      //     type: data.parent.type + 1,
      //     study_type: 1,
      //     study_id: data.item.model_id,
      //     resource_id: data.parent.resource_id
      //   }),
      //   (res) => {
      //   }
      // )
      HttpFactory.postUrl(
        rqParams.getmodelinfo({
          model_id: data.item.model_id
        }),
        (res) => {
          const paper_list = res.data.paper_list || []
          if (paper_list.length > 0) { // 进入试卷模式
            location.href = './EnglishPaperTest.html?title=' + data.parent.resource_name + '&book_id=' + this.book_id + '&type=' + data.parent.type + '&resource_id=' + data.parent.resource_id + '&model_id=' + data.item.model_id + '&son_type=' + data.item.type + '&if_study=' + data.item.if_study + `&business_id=${this.business_id}`
          } else {
            this.goqusDetailFun(res, data)
          }
        }
      )
    },
    deal(nodes, predicate) {
      // 如果已经没有节点了，结束递归
      if (!(nodes && nodes.length)) {
        return []
      }
      const newChildren = []
      for (const node of nodes) {
        if (predicate(node)) {
          // 如果节点符合条件，直接加入新的节点集
          newChildren.push(node)
          node.children = this.deal(node.children_list, predicate)
        } else {
          // 如果当前节点不符合条件，递归过滤子节点，
          // 把符合条件的子节点提升上来，并入新节点集
          newChildren.push(...this.deal(node.children_list, predicate))
        }
      }
      return newChildren
    },
    goqusDetailFun(res, data) {
      const model_info = res.data.model_info
      const qus = res.data.question_list[0]
      if (model_info.new_type == 12 || model_info.new_type == 2) { // 图文模块
        this.nowSubmitStudyRecord(data).then(result => {
          this.goImgTextModel(data.item, res)
        })
      } else if (model_info.new_type == 53) { // 课文点读
        this.nowSubmitStudyRecord(data).then(result => {
          this.goClickRead(data.item, res)
        })
      } else if (!qus) {
        this.$toast('跳转失败，请直接退出')
      } else if (qus.sub_model_id == 5) {
        location.href = './EnglishListeningQuestions.html?guid=' + qus.guid + '&title=' + data.parent.resource_name + '&book_id=' + this.book_id + '&type=' + data.parent.type + '&resource_id=' + data.parent.resource_id + '&model_id=' + data.item.model_id + '&son_type=' + data.item.type + '&if_study=' + data.item.if_study + '&model_name=' + data.item.model_name + `&business_id=${this.business_id}`
      } else if (qus.model_id === 11) {
        if (qus.sub_model_id == 1) {
          location.href = './EnglishAnalogFollowUpReading.html?guid=' + qus.guid + '&title=' + data.parent.resource_name + '&book_id=' + this.book_id + '&type=' + data.parent.type + '&resource_id=' + data.parent.resource_id + '&model_id=' + data.item.model_id + '&son_type=' + data.item.type + '&if_study=' + data.item.if_study + `&business_id=${this.business_id}`
        } else if (qus.sub_model_id == 2) {
          location.href = './EnglishOralExpression.html?guid=' + qus.guid + '&title=' + data.parent.resource_name + '&book_id=' + this.book_id + '&type=' + data.parent.type + '&resource_id=' + data.parent.resource_id + '&model_id=' + data.item.model_id + '&son_type=' + data.item.type + '&if_study=' + data.item.if_study + `&business_id=${this.business_id}`
        } else if (qus.sub_model_id == 3) {
          location.href = './EnglishOralAnswerQuestions.html?guid=' + qus.guid + '&title=' + data.parent.resource_name + '&book_id=' + this.book_id + '&type=' + data.parent.type + '&resource_id=' + data.parent.resource_id + '&model_id=' + data.item.model_id + '&son_type=' + data.item.type + '&if_study=' + data.item.if_study + `&business_id=${this.business_id}`
        } else if (qus.sub_model_id == 4) {
          location.href = './EnglishOralExpressionTraining.html?guid=' + qus.guid + '&title=' + data.parent.resource_name + '&book_id=' + this.book_id + '&type=' + data.parent.type + '&resource_id=' + data.parent.resource_id + '&model_id=' + data.item.model_id + '&son_type=' + data.item.type + '&if_study=' + data.item.if_study + `&business_id=${this.business_id}`
        }
      } else {
        setTimeout(() => {
          this.$toast('题目信息不正确')
        }, 800)
      }
    },
    nowSubmitStudyRecord(data) {
      return new Promise((resolve, reject) => {
        HttpFactory.postUrl(
          rqParams.submitbookstudyrecord({
            book_id: this.book_id,
            type: data.parent.type + 1,
            study_type: 2,
            study_id: data.item.model_id,
            resource_id: data.parent.resource_id
          }),
          res => {
            resolve()
          }
        )
      })
    },
    /**
     * 跳转图文模块
     */
    goImgTextModel(item, req) {
      const res = req.data
      let url = `${basePageUrlWeb('vant')}/contentsPage.html`
      const parms = {
        model_name: res.model_info.name,
        type: res.model_info.new_type,
        question_mode: res.model_info.question_mode,
        permission: res.model_info.permission,
        model_id: res.model_info.id,
        model_type: res.model_info.type
      }
      const Scope = zhlType.getScope()
      const business_id = zhlType.getBusinessId()
      // if (this.business_id === 200414) {
      //   Scope = getTerminal() == 'ios' ? 'com.zhl.yj.listen.iphone.web' : 'com.zhl.yj.listen.aphone.web'
      //   business_id = 200414
      // }
      let model_list = JSON.stringify([parms])
      model_list = model_list.replace(/"/gi, '\\"')
      // &course_id=${this.book_info.id}  删除了这段
      url +=
        `?resource_id=${res.model_info.catalog_id}&subject_id=${this.book_info.subject_id}&click_model_id=${item.model_id}&title=${res.model_info.name}&model_list=${model_list}&grade_id=${this.userInfo.grade_id}&user_id=${this.userInfo.user_id}&userPeriod=${this.userInfo.period}&phrase=${this.userInfo.period}&grade_id=${this.userInfo.grade_id}&volume_id=${this.book_info.volume}` +
        '&Scope=' +
        Scope +
        '&token=' +
        getCookie('token') +
        '&business_id=' +
        business_id +
        '&UID=' +
        this.userInfo.user_id
      console.log(url)
      location.href = url
    },
    /**
     * 跳转课文点读对应模块位置
     */
    goClickRead(item, res) {
      const click_read_en = res.data.click_read_en
      const Scope = zhlType.getScope()
      const business_id = zhlType.getBusinessId()
      const token = getCookie('token')
      // if (this.business_id === 200414) {
      //   Scope = getTerminal() == 'ios' ? 'com.zhl.yj.listen.iphone.web' : 'com.zhl.yj.listen.aphone.web'
      //   business_id = 200414
      // }
      const params = {
        business_id: business_id,
        book_id: this.book_info.id,
        grade_id: this.book_info.grade_id,
        volume_id: this.book_info.volume,
        subject_id: this.book_info.subject_id,
        book_type: this.book_info.type,
        start_page_code: click_read_en.start_page_code,
        end_page_code: click_read_en.end_page_code,
        Scope: Scope,
        token: token
      }
      jumpPageUrlWeb('primary', `#/clickRead/clickReadDetails${httpBuilderUrl(params)}`, true)
      return false
    },
    getNextList() {
      HttpFactory.postUrl(
        rqParams.getlistenspeakinfov2({
          book_id: this.book_id
        }),
        res => {
          this.book_info = res.data.book_info
          this.nextList = res.data.catalog_list
        }
      )
    },
    // 发送
    send() {
      this.$refs.zhlAplayer && this.$refs.zhlAplayer.stop()
      let dataFormApp = Object.assign({}, this.currentObj)
      this.messageList.forEach((el) => {
        if (el.isAskLuyin) {
          dataFormApp = Object.assign({}, el)
        }
      })
      const msgs = dataFormApp.msg.replace(/<.*?>/gi, '')
      this.beginLu(msgs)
      // var json = { oralText: msgs }
      // var str = JSON.stringify(json)
      // // 调用语音评测
      // if (typeof zhlWebView != 'undefined') {
      //   if (this.theGuid) {
      //     this.hideFooter = true
      //   }
      //   zhlWebView.oralEvaluation(str)
      // }
    },
    nextReading() {
      this.messageList.forEach((el) => {
        el.isPlaying = false
        el.isAskLuyin = false
      })
      const index = this.currentIndex
      this.aiSend(index)
    },
    aiSend(index) {
      if (this.isPlaying) {
        return
      }
      this.$refs.zhlAplayer && this.$refs.zhlAplayer.stop()
      this.isPlaying = true
      index = index || 0
      const readObj = this.listArr[index]
      this.currentObj = {
        url: readObj.extra.audio_url,
        avatar_url: readObj.extra.avatar_url,
        audio_duration: readObj.extra.audio_duration,
        type: 'left',
        msg: readObj.option,
        isPlaying: true,
        // isShowText: !!this.hideHeader
        isShowText: !readObj.extra.audio_duration
      }
      this.curretIndex = index
      this.currentIndex++
      this.messageList.push(this.currentObj)
    },
    getDataList(fn) {
      if (this.theGuid && JSON.stringify(this.questionItem) != '{}') {
        this.stems = this.questionItem.stem
        this.audioUrl = this.questionItem.audio_url
        const obj = this.questionItem.options
        const dataArr = obj.data
        const roleArr = obj.role
        // this.title = res.data.stem.replace(/<.*?>/gi, '')
        dataArr.forEach((el) => {
          el.option = this.replaceKun(el.option)
          roleArr.forEach((sub) => {
            if (el.extra.avatar_id == sub.avatar_id) {
              el.extra = Object.assign(el.extra, sub)
            }
          })
        })
        this.listArr = obj.data
        if (this.hideHeader && this.currentIndex == 0) {
          this.aiSend(0)
        }
        if (fn) {
          fn()
        }
        return
      }
      const reqWay = this.record_id ? 'postNotoken' : 'postUrl'
      HttpFactory[reqWay](
        rqParams.getquestioninfo({
          guid: this.guid,
          sign: md5(this.guid + '&zhl_qiaokao')
        }),
        (res) => {
          this.model_question = res.data
          this.stems = res.data.stem
          this.audioUrl = res.data.audio_url
          const obj = JSON.parse(res.data.options)
          const dataArr = obj.data
          const roleArr = obj.role
          // this.title = res.data.stem.replace(/<.*?>/gi, '')
          this.stem = res.data.stem.replace(/<.*?>/gi, '')
          dataArr.forEach((el) => {
            el.option = this.replaceKun(el.option)
            roleArr.forEach((sub) => {
              if (el.extra.avatar_id == sub.avatar_id) {
                el.extra = Object.assign(el.extra, sub)
              }
            })
          })
          this.listArr = obj.data
          // if (this.hideHeader && this.currentIndex == 0) {
          //   this.aiSend(0)
          // }

          if (fn) {
            fn()
          }
          if (this.record_id) {
            this.getuserpracticerecorddetail()
          }
        }
      )
    },
    // 获取练习记录详情
    getuserpracticerecorddetail() {
      const reqWay = this.record_id ? 'postNotoken' : 'postUrl'
      HttpFactory[reqWay](
        rqParams.getuserpracticerecorddetail({
          record_id: this.record_id
        }),
        (res) => {
          const remark = JSON.parse(res.data.remark)
          this.messageList = remark.messageList
          console.log(remark)
        }
      )
    },
    replaceKun(str) {
      return str.replace(/{_.*?_}/gi, (s1) => {
        const result = s1.split('_')
        return result[1]
      })
    },
    // 状态改变时触发
    onKDXFWillStatusChange(oldStatus, status) {
      // this.isLuing = status === 'ing'
    },
    onKDXFTextChange(grade) {
      // console.log('iseRecorder.onTextChange==>', grade)
      // console.log(JSON.stringify(grade))
      console.log(grade)
      const readSentence = grade?.xml_result?.read_sentence?.rec_paper?.read_chapter
      this.KDXFCallback(readSentence)
    },
    KDXFCallback(readSentence) {
      this.hideFooter = false
      const isVip = true
      let str = ''
      try {
        str = this.getKDXFResultStr(readSentence)
      } catch (error) {
        str = readSentence.content
      }
      if (isVip) {
        const obj = {
          id: new Date().getTime() + Math.random(),
          // url: iseRecorder.getAudioLocalUrl(),
          avatar_url: this.userInfo.avatar_url,
          audio_duration: iseRecorder.mediaSource.context.currentTime,
          isVip: true,
          type: 'right',
          msg: str,
          // 总分
          // grade: data.overall ? data.overall : 0,
          grade: Math.round((Number(readSentence.total_score) || 0) * 20),
          isPlaying: true,
          isAskLuyin: false
        }
        const activeBookInfo = sessionStorage.getItem('activeBookInfo')
        let book_name = ''
        if (activeBookInfo) {
          const { name } = JSON.parse(activeBookInfo)
          book_name = name || ''
        }
        iseRecorder.setAudioUrl(obj, {
          formDataBack: (formData) => {
            formData.append('file_path_key', book_name)
          }
        })
        this.currentObj = obj
      } else {
        const obj = {
          id: new Date().getTime() + Math.random(),
          // url: iseRecorder.getAudioLocalUrl(),
          avatar_url: this.userInfo.avatar_url,
          audio_duration: iseRecorder.mediaSource.context.currentTime,
          isVip: false,
          type: 'right',
          msg: str,
          isPlaying: true,
          isAskLuyin: false
        }
        iseRecorder.setAudioUrl(obj)
        this.currentObj = obj
      }
      let num = 0
      this.messageList.forEach((el, i) => {
        if (el.isAskLuyin) {
          this.messageList.splice(i, 1, this.currentObj)
          num++
        }
      })
      if (!num) {
        this.messageList.push(this.currentObj)
        if (!this.isShowGetVip && !isVip) {
          this.messageList.push({
            type: 'other',
            msg: '想要查看自己的口语分数吗？'
          })
        }
      }
      this.askLuyin = false
    },
    getKDXFResultStr(readSentence) {
      var srt = ''
      var obj = {}
      let wordArr = []
      const sentence = readSentence?.sentence || []
      if (Array.isArray(sentence)) {
        sentence.forEach(v => {
          if (Array.isArray(v.word)) {
            wordArr.push(...v.word)
          } else {
            wordArr.push(v.word)
          }
        })
      } else {
        if (Array.isArray(sentence.word)) {
          wordArr = sentence.word
        } else {
          wordArr = [sentence.word]
        }
      }
      wordArr.forEach((el) => {
        srt += el.content + '|'
        if (el.total_score >= 3) {
          obj[el.content.toLowerCase()] = '<span class="green">' + el.content + '</span>'
        } else {
          obj[el.content.toLowerCase()] = '<span class="red">' + el.content + '</span>'
        }
      })
      srt = srt.slice(0, srt.length - 1)
      try {
        const reg = new RegExp('(' + srt + ')', 'gi')
        const newLine = readSentence.content.replace(reg, ($0, $1) => {
          const result = obj[$1.toLowerCase()] ? obj[$1.toLowerCase()] : $0
          return result.replace($0.toLowerCase(), $0)
        })
        return newLine
      } catch (error) {
        return readSentence.content
      }
    },
    play(arrayBuffer) {
      // Safari需要使用webkit前缀
      const AudioContext = window.AudioContext || window.webkitAudioContext
      const audioContext = new AudioContext()
      // 创建一个AudioBufferSourceNode对象，使用AudioContext的工厂函数创建
      const audioNode = audioContext.createBufferSource()
      // 解码音频，可以使用Promise，但是较老的Safari需要使用回调
      iseRecorder.audioContext.decodeAudioData(new Uint16Array(arrayBuffer).buffer, function(audioBuffer) {
        console.log(audioBuffer)
        audioNode.buffer = audioBuffer
        audioNode.connect(audioContext.destination)
        // 从0s开始播放
        audioNode.start(0)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.conten-box {
  position: relative;
  height: 100%;
  font-family: PingFangSC-Medium, PingFang SC;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .header {
    /deep/ .van-nav-bar__title {
      font-size: 16px;
      font-weight: bold;
      color: rgba(69, 70, 74, 1);
    }

    /deep/ .van-icon {
      &:active {
        background: #f5f5f5;
      }
    }
  }

  .cont {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .progress {
      padding: 0 15px;
      margin-bottom: 20px;
    }

    .wapper {
      flex: 1;
      overflow: auto;

      .w-title {
        padding: 0 15px;
        display: flex;
        align-items: center;
        padding-bottom: 30px;

        /*&.noShow {*/
        /*  padding: 0;*/
        /*}*/

        .tag {
          width: 68px;
          height: 25px;
          line-height: 25px;
          text-align: center;
          font-size: 12px;
          font-weight: bold;
          color: rgba(255, 255, 255, 1);
          margin-right: 7px;
          background: rgba(116, 118, 125, 1);
          border-radius: 4px;
        }

        .msg {
          font-size: 14px;
          font-weight: bold;
          color: rgba(69, 70, 74, 1);
          line-height: 20px;
          flex: 1;
        }
      }
      .player-box {
        padding: 0 15px;
        margin-bottom: 30px;
        position: relative;

        /deep/ .aplayer-info {
          padding-right: 54px !important;
        }

        &.noPadding {
          /deep/ .aplayer-info {
            padding-right: 0px !important;
          }
        }
      }
      .msg-box {
        padding: 0 15px;

        .textBox {
          background: #f5f7fa;
          border-radius: 10px;
          padding: 20px;
          box-sizing: border-box;
          margin-bottom: 15px;
          text-align: justify;
          font-size: 15px;
          color: #45464a;
          line-height: 26px;
        }
      }
    }
  }

  .footer {
    height: 140px;
    display: flex;
    align-items: center;
    justify-content: center;

    .footer-item {
      margin-top: 30px;
      user-select: none;

      /deep/ .van-icon {
        &:active {
          opacity: 0.8;
        }
      }
      .backGroundLuYin {
        width: 92px;
        height: 92px;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
      }

      .name {
        text-align: center;
        font-size: 12px;
        font-weight: bold;
        color: rgba(164, 167, 176, 1);
        margin-top: 22px;
      }

      &:nth-child(2) {
        margin: 0 50px;

        .name {
          margin-top: 0;
        }
      }
    }
  }

  .asklu {
    height: 140px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 10px 0px rgba(53, 63, 79, 0.06);
    padding: 15px 0;
    box-sizing: border-box;
    flex-direction: column;

    .progressBox {
      position: absolute;
      width: 100%;
      left: 0;
      top: 10px;
      padding: 0 15px;
      box-sizing: border-box;
      display: flex;
      align-items: center;

      .pro {
        flex: 1;
        overflow: hidden;
      }

      .timeBox {
        margin-left: 5px;
        font-size: 12px;
        color: #a4a7b0;
      }
    }

    .waveBox {
      width: 100%;
      flex: 1;
      overflow: hidden;
      display: flex;
      align-items: center;
    }

    .text {
      font-size: 13px;
      font-family: PingFang-SC-Regular, PingFang-SC;
      font-weight: 400;
      color: rgba(69, 70, 74, 1);
    }
    .stopLuBtn {
      display: flex;
      align-items: center;
      justify-content: center;
      & > div {
        width: 90px;
        height: 26px;
        font-size: 13px;
        color: white;
        background: #4ddc8c;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 6px;
      }
    }
  }

  .player {
    display: none;
  }

  .showCountDown {
    flex-direction: column;

    .van-count-down {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 20px;
      font-weight: bold;
      color: #ffffff;
      width: 50px;
      height: 50px;
      background: linear-gradient(128deg, #5cea9b 0%, #45d585 100%);
      border-radius: 51px;
      margin-bottom: 8px;
    }

    .text {
      font-size: 14px;
      color: #a4a7b0;
      line-height: 28px;
    }
  }
  /*/deep/ .van-popup--center{*/
  /*    left: 0;*/
  /*    top: 0;*/
  /*    transform: unset;*/
  /*}*/
  .showFAlertBox {
    /*position: absolute;*/
    /*left: 50%;*/
    /*top: 50%;*/
    /*transform: translate(-50%, -50%);*/
    background: transparent;
    .showFAlert {
      background: #fff;
      width: 293px;
      padding: 20px;
      box-sizing: border-box;
      border-radius: 10px;

      .title {
        font-size: 16px;
        font-weight: bold;
        color: #45464a;
        line-height: 16px;
        margin-bottom: 18px;
        text-align: center;
      }

      .msg {
        font-size: 14px;
        color: #74767d;
        line-height: 26px;
        text-align: center;
        margin-bottom: 20px;
      }

      .btns {
        width: 100%;
        display: flex;
        justify-content: space-between;

        /deep/ .van-button {
          width: 120px;
          height: 40px;
          border-color: #45d585;
          background: #45d585;
          font-size: 16px;
          font-weight: bold;
          color: #ffffff;

          &:first-child {
            border-color: #979797;
            background: #fff;
            color: #74767d;
          }
        }
      }
    }
  }
}
</style>
